export const DATE_STRING_REGEX =
  /^(\d{4})-(0[1-9]|1[0-2])-([0-2][0-9]|3[0-1])$/;
export const TIME_STRING_REGEX = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;
export const PHONE_NUMBER_REGEX =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
